import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export default class Tooltip {
    tooltip: any;

    static init(scope = $('body')) {
        $(scope)
            .find('.js-tooltip')
            .each((i, item) => {
                const tooltip = new Tooltip($(item));
                tooltip.init();
            });
    }

    constructor(tooltip) {
        this.tooltip = tooltip;
    }

    init() {
        this.bindings();
    }

    bindings() {
        tippy(this.tooltip[0], {
            allowHTML: true,
            trigger: 'click',
            arrow: true,
            theme: 'tooltip'
        });
    }
}
